<template>
  <q-tr class="top-filter-row">
    <q-td></q-td>
    <q-td v-for="column in cols" :key="column.name">
      <q-field v-if="column.filterable">
        <component
          :resource="resource"
          :is="column | filterIs"
          v-bind="column.component ? column.component.props : {}"
          :clearable="true"
          :align="column.align"
          :hide-underline="true"
          :value="activeFilterKeys[column.field]"
          template="filter"
          :is-filter="true"
          placeholder="All"
          :column="column"
          @remove="handleRemoveFilter(column)"
          @apply="applyFilter(column, $event)"
        />
      </q-field>
      <span v-else></span>
    </q-td>
  </q-tr>
</template>
<script>

export default {
  name: 'FilterBar',
  props: ['resource', 'cols'],
  filters: {
    filterIs (column) {
      if (column && column.component && column.component.filterIs) {
        return column.component.filterIs
      }
      if (column.type === 'date') {
        return 'date-filter'
      }
      if (column.component) {
        if (column.component.is === 'q-input') {
          return 'text-filter'
        }
        return column.component.filterIs || 'text-filter'
      }
      return 'text-filter'
    }
  },
  computed: {
    activeFilterKeys () {
      return this.$store.getters[`${this.resource}/filters`].columns
    },
    fakeColumns () {
      return this.$store.state[this.resource].fakeColumns
    }
  },
  methods: {
    notifyParent () {
      this.$emit('change')
    },
    applyFilter (column, value) {
      // console.log('>> apply filter', column, value)
      if (value === null || value === undefined || value === '') {
        this.handleRemoveFilter(column)
        return
      }
      // console.log('value', value, 'value.isArray', Array.isArray(value), 'typeof value', typeof value, value.length)

      if (this.fakeColumns && this.fakeColumns[column.field]) {
        // console.log('>> fake column', this.fakeColumns[column.field])
        // if (this.fakeColumns[column.field] === 'companyDivision') {
        //   let newArray = []
        //   for (const val of value) {
        //     console.log('val', val)
        //     newArray.push(val)
        //   }
        //   console.log('newArray', newArray, 'value', value, 'Array.isArray(newArray)', Array.isArray(newArray))
        //   // const newValue = Object.keys(value).map(i => value[i])
        //   // console.log('newValue', newValue, 'newValue.isArray', newValue.isArray)
        //   // value = newValue
        //   // correct = [{companyDivision: [], description: null, id:1}]
        //   // incorrect = {companyDivision: {companyDivision: [], description: null, id:1}}
        // }
        if (value !== undefined && value !== null) {
          // console.log('value', value, 'value.isArray', value.isArray, 'typeof value', typeof value, value.length)
          if (typeof value === 'object' && !Array.isArray(value)) {
            // console.log('found object filter!')
            const firstValue = Object.values(value)[0]
            const newValue = {
              [column.field]: firstValue
            }
            this.$store.commit(`${this.resource}/SET_COLUMN_FILTER`, {
              field: column.field,
              value: newValue
            })
            this.notifyParent()
            return
          }
        }
      }

      this.$store.commit(`${this.resource}/SET_COLUMN_FILTER`, {
        field: column.field,
        value
      })
      this.notifyParent()
    },
    handleRemoveFilter (column) {
      // console.log('remove filter')
      this.$store.commit(`${this.resource}/CLEAR_COLUMN_FILTER`, column.field)
      this.notifyParent()
    },
    handleChange (column, value) {
      // console.log('handle change:')
      // console.log(column.field)
      // console.log(value)
      if (value === null || value === undefined || value === '') {
        this.handleRemoveFilter(column)
      }
      if (typeof value === 'object' && !Array.isArray(value)) {
        if (column.relation && column.relation.namespace) {
          this.$store.commit(`${this.resource}/SET_COLUMN_FILTER`, {
            field: column.field,
            value
          })
          this.notifyParent()
          return
        }
      }
      // -- handle normal column
      this.$store.commit(`${this.resource}/SET_COLUMN_FILTER`, {
        field: column.field,
        value: value
      })
      this.notifyParent()
    },
    handleFilters () {
      /*
      const newFilters = {
        ...this.activeFilters,
        ...this.filterModels
      }
      */
      // this.$store.commit(`${this.resource}/SET_FILTER`, {field: 'columns', value: this.filterModels})
      this.$q.notify({
        message: 'Filters Applied',
        icon: 'filter_list',
        type: 'positive'
      })
      this.$emit('change')
    }
  }
}
</script>
